import { render, staticRenderFns } from "./VTenantForm.vue?vue&type=template&id=46e8f6ce"
import script from "./VTenantForm.vue?vue&type=script&lang=js"
export * from "./VTenantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports